<template>
  <div class="zb-box">
    <div class="zb-box-left">
      <tengxunyunzb ref="txyzb"/>
    </div>
    <div class="zb-box-right">
	  <div class="zb-box-right-top">
	  	<div class="zb-box-right-name">{{$t('all.zhibojianbiaoti')}}</div>
	  	<div class="zb-box-right-title">
	  		<input v-model="form.name" type="text" :placeholder="$t('all.geinidezhibojianqugemingziba')"/>
	  	</div>
	  	<div class="zb-box-right-name">{{$t('all.zhibojianbeijing')}}</div>
	  	<div class="zb-box-right-bj">
	  		<img
	  		  class="zb-box-right-bj-img"
	  		  src="../../../assets/image/tianjia_tupian@2x.png"
	  		  alt="添加图片"
	  		  @click="handleUploadClick"
	  		  v-if="!form.backgroundUrl"
	  		/>
	  		<img class="zb-box-right-bj-img" v-if="form.backgroundUrl" :src="form.backgroundUrl" alt="" @click="handleUploadClick"/>
	  		<!-- 隐藏的文件选择器 -->
	  		<input
	  		  type="file"
	  		  ref="fileInput"
	  		  style="display: none"
	  		  accept="image/*"
	  		  @change="handleFileChange"
	  		/>
	  	</div>
	  	<div class="zb-box-right-name">{{$t('all.zhibojianbiaoqian')}}</div>
	  	<div class="zb-box-right-bq">
	  		<div :class="bqListIndex === index?'zb-box-right-bq-item':'zb-box-right-bq-item1'" v-for="(item,index) in bqList" :key="index" @click="handleBq(index)">{{item.categoryName}}</div>
	  	</div>
	  	<div class="zb-box-right-name">{{$t('all.zhibojianhuazhi')}}</div>
	  	<div class="zb-box-right-bq">
	  		<div :class="hzListIndex === index?'zb-box-right-bq-item':'zb-box-right-bq-item1'" v-for="(item,index) in hzList" :key="index" @click="handleHz(index)">{{item.label}}</div>
	  	</div>
	  </div>
	  <div class="zb-box-right-bottom">
	  	<input v-model="form.startKey" :placeholder="$t('all.qingshurukaibomiyao')" type="text" />
		<div class="zb-box-right-bottom-btn" @click="startLive">{{$t('all.kaishizhibo')}}</div>
	  </div>
    </div>
  </div>
</template>

<script>
import { getLiveCategoryList,startLive } from "@/api/zhibo";
import { client as createCosClient } from '../../../common/js/txycos';
import tengxunyunzb from "../../../components/tengxunyunzb/tengxunyunzb.vue"
export default {
  components: {
    tengxunyunzb
  },
  data() {
    return {
	  livePusher:null,
	  form:{
		  name:'',
		  backgroundUrl:'',
		  categoryId:'',
		  livePictureQuality:0,
		  startKey:'',
	  },
	  bqList:[],
	  bqListIndex:0,
	  hzList:[{
		  value:0,
		  label:this.$t('all.gaoqinghuazhi')
	  },{
		  value:1,
		  label:this.$t('all.putonghuazhi')
	  }],
	  hzListIndex:0,
	  cosClient: null,
    };
  },
  mounted() {
	this.getLiveCategoryList()
	this.getLivePusher()
	this.$store.commit('changeCount', 3);
	this.cosClient = createCosClient();
  },
  methods: {
	//直播分类
	async getLiveCategoryList(){
		const res = await getLiveCategoryList()
		this.bqList = res.data
		this.form.categoryId = res.data[0].id
	},
	getLivePusher(){
		this.livePusher = new TXLivePusher();
		this.livePusher.setRenderView('local_video');
		this.livePusher.videoView.muted = true;
		// 设置视频质量
		this.livePusher.setVideoQuality('720p');
		// 设置音频质量
		this.livePusher.setAudioQuality('standard');
		// 自定义设置帧率
		this.livePusher.setProperty('setVideoFPS', 25);
		// 打开摄像头
		this.livePusher.startCamera();
		// 打开麦克风
		this.livePusher.startMicrophone();
	},
	//选择标签
	handleBq(index){
		this.bqListIndex = index
		this.form.categoryId = this.bqList[index].id
	},
	//选择画质
	handleHz(index){
		this.hzListIndex = index
		this.form.livePictureQuality = this.hzList[index].value
		this.$refs.txyzb.setVideoQuality(index)
	},
	
	// 触发文件选择（原有逻辑不变，无需修改）
	handleUploadClick() {
	  this.$refs.fileInput.click();
	},

	// 处理文件选择（原有逻辑优化，适配 COS 上传）
	handleFileChange(event) {
	  const fileList = event.target.files;
	  if (!fileList || fileList.length === 0) return;
	  // 仅上传第一张图片（符合页面单张背景图的需求）
	  this.uploadToCOS(fileList[0]);
	  // 重置文件输入框，避免重复选择同一文件不触发 change 事件
	  event.target.value = '';
	},

	// 核心改造：腾讯云 COS 单张图片上传（替换原有阿里云 OSS 上传）
	async uploadToCOS(file) {
	  // 校验 1：文件是否合法
	  if (!file || !file.type.startsWith('image/')) {
		this.$message.error('请选择有效的图片文件');
		return;
	  }
	  try {
		// 1. 构造唯一文件名（按直播背景图分类存储，方便管理）
		const fileExt = file.name.split('.').pop() || 'png';
		const fileName = `webStorage/web_/${Date.now()}_${Math.random().toString(36).substr(2, 10)}.${fileExt}`;

		// 2. 调用 COS putObject 方法上传（回调转 Promise，适配 async/await）
		const uploadResult = await new Promise((resolve, reject) => {
		  this.cosClient.putObject({
			Bucket: this.cosClient.options.bucket,
			Region: this.cosClient.options.region,
			Key: fileName,
			Body: file,
			ContentType: file.type || 'image/jpeg', // 兜底图片 MIME 类型
			onProgress: (progressData) => {
			  // 可选：上传进度回调，如需显示进度可在此扩展
			  console.log('图片上传进度：', (progressData.percent * 100).toFixed(2) + '%');
			}
		  }, (err, result) => {
			if (err) reject(err);
			else resolve(result);
		  });
		});

		// 3. 拼接 COS 图片访问 URL，赋值给表单背景图
		const imageUrl = `https://${this.cosClient.options.bucket}.cos.${this.cosClient.options.region}.myqcloud.com/${fileName}`;
		// 或使用 uploadResult.Location 直接获取完整 URL：
		// this.form.backgroundUrl = `https://${uploadResult.Location}`;
		this.form.backgroundUrl = imageUrl;

		// this.$message.success('直播背景图上传成功');
		console.log('背景图上传成功，地址：', this.form.backgroundUrl);

	  } catch (error) {
		console.error('直播背景图上传失败：', error);
		this.$message.error('背景图上传失败，请稍后重试');
	  }
	},
	//开始直播
	async startLive(){
		const res = await startLive(this.form)
		this.$store.commit('changeLiveId', res.data); // 调用 setCount mutation 并传递参数
		this.$router.push({ path: '/zhibojian',query:{liveId:res.data}});
	}

  },
  beforeDestroy() {
  	this.livePusher.destroy()
  }
};
</script>
<style scoped lang="scss">
	@import "./zhibo.css";
</style>


// WEBPACK FOOTER //
// zhibo.vue?15c98ef0